export const generateHeader = async (title) => {
  const { LOGO } = await import('lib/pdfs/logo');

  return {
    columns: [
      {
        margin: [0, 23, 0, 0],
        width: 70,
        image: LOGO,
      },
      {
        text: title,
        bold: true,
        fontSize: 13,
        style: 'textStyle',
      },
    ],
    columnGap: 20,
  };
};

/* 
 * CFM custom security voucher
 * @author Jorge Casas
 * @creationDate 23/05/2023
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderCFM = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoCFM');

  return {
    columns: [
      {
        margin: [60, -20, 0, 0],
        width: 70,
        height: 70,
        image: LOGO,
      },
    ],
    columnGap: 20,
  };
};

/* 
 * Televía custom security voucher
 * @author Jorge Casas
 * @creationDate 24/05/2023
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderTelevia = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoTelevia');

  return {
    columns: [
      {
        margin: [20, -20, 0, 0],
        width: 130,
        height: 70,
        image: LOGO,
      },
      {
        margin: [250, 0, 0, 0],
        text: title,
        bold: true,
        fontSize: 13,
        alignment: 'right',
        style: 'textStyle',
        color: '#0e813c'
      },
    ],
    columnGap: 20,
  };
};

/* 
 * Schutz custom security voucher
 * @author Jorge Casas
 * @creationDate 21/08/2023
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderSchutz = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoSchutz');

  return {
    columns: [
      {
        margin: [20, -20, 0, 0],
        width: 130,
        height: 70,
        image: LOGO,
      },
      {
        margin: [250, 0, 0, 0],
        text: title,
        bold: true,
        fontSize: 13,
        alignment: 'right',
        style: 'textStyle',
        color: '#0e813c'
      },
    ],
    columnGap: 20,
  };
};

/* 
 * Solarever custom security voucher
 * @author Jorge Casas
 * @creationDate 09/04/2024
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderSolarever = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoSolarever');

  return {
    columns: [
      {
        margin: [20, -20, 0, 0],
        width: 130,
        height: 70,
        image: LOGO,
      },
      {
        margin: [70, 0, 0, 0],
        text: title,
        bold: true,
        fontSize: 13,
        alignment: 'right',
        style: 'textStyle',
        color: '#0e813c'
      },
    ],
    columnGap: 20,
  };
};

/* 
 * Circulo de crédito custom security voucher
 * @author Jorge Casas
 * @creationDate 05/07/2024
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderCirculoDeCredito = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoCirculoDeCredito');

  return {
    columns: [
      {
        margin: [20, -20, 0, 0],
        width: 150,
        height: 60,
        image: LOGO,
      },
      {
        margin: [70, 0, 0, 0],
        text: title,
        bold: true,
        fontSize: 13,
        alignment: 'right',
        style: 'textStyle',
        color: '#0e813c'
      },
    ],
    columnGap: 20,
  };
};

/* 
 * Circulo laboral custom security voucher
 * @author Jorge Casas
 * @creationDate 06/07/2024
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderCirculoLaboral = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoCirculoLaboral');

  return {
    columns: [
      {
        margin: [20, -20, 0, 0],
        width: 150,
        height: 60,
        image: LOGO,
      },
      {
        margin: [70, 0, 0, 0],
        text: title,
        bold: true,
        fontSize: 13,
        alignment: 'right',
        style: 'textStyle',
        color: '#0e813c'
      },
    ],
    columnGap: 20,
  };
};

/* 
 * RUV (Registro Único de Vivienda) custom security voucher
 * @author Jorge Casas
 * @creationDate 11/09/2024
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderRUV = async (title) => {
  const { LOGO } = await import('lib/pdfs/logoRUV');

  return {
    columns: [
      {
        margin: [20, -20, 0, 0],
        width: 150,
        height: 60,
        image: LOGO,
      },
      {
        margin: [70, 0, 0, 0],
        text: title,
        bold: true,
        fontSize: 13,
        alignment: 'right',
        style: 'textStyle',
        color: '#0e813c'
      },
    ],
    columnGap: 20,
  };
};

/* 
 * Geldmacht custom security voucher
 * @author Erick Servin
 * 
 * @param {String} title
 * @returns {Object} header
 */
export const generateHeaderGeldmacht = async ({
  companyName,
  title,
  subtitle,
  date,
}) => {
  const { LOGO } = await import('lib/pdfs/logo');
  const { LOGO1, LOGO2 } = await import('lib/pdfs/logoGeldmacht');

  const formatImage = (img) => {
    if (!img) return '';

    return img.startsWith('data:image')
      ? img
      : `data:image/png;base64,${img}`;
  };

  return {
    margin: [0, -5, 0, 14],
    table: {
      widths: [110, '*', 110],
      body: [
        [
          {
            stack: [
              {
                image: formatImage(LOGO1),
                width: 58,
                alignment: 'left',
                margin: [0, 0, 0, 10],
              },
              {
                text: 'Generado por',
                fontSize: 5,
                color: '#9aa5ad',
                margin: [0, 0, 0, 1],
              },
              {
                image: LOGO,
                width: 28,
                alignment: 'left',
                opacity: 0.45,
              },
            ],
            border: [false, false, false, false],
          },
          {
            stack: [
              {
                text: companyName || '',
                bold: true,
                fontSize: 13,
                alignment: 'center',
                color: '#45535b',
                margin: [0, 20, 0, 10],
              },
              {
                text: title || '',
                bold: true,
                fontSize: 18,
                alignment: 'center',
                color: '#344955',
                margin: [0, 0, 0, 3],
              },
              {
                text: subtitle || '',
                fontSize: 9,
                alignment: 'center',
                color: '#6c757d',
              },
            ],
            border: [false, false, false, false],
          },
          {
            stack: [
              {
                image: formatImage(LOGO2),
                width: 52,
                alignment: 'right',
                margin: [0, 0, 0, 16],
              },
              {
                text: date || '',
                bold: true,
                fontSize: 8,
                alignment: 'right',
                color: '#45535b',
              },
            ],
            border: [false, false, false, false],
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
};

/* 
 * Caja Popular 9 de Agosto custom security voucher
 * @author Jorge Casas
 * @dateCreate 10/06/2026
 * 
 * @param {Object} titleConfig - optional right column config
 * @returns {Object} header
 */
export const generateHeaderCajaPopular9Agosto = async (titleConfig) => {
  const { LOGO: LOGO_CAJA } = await import('lib/pdfs/logoCajaPopular9Agosto');
  const { LOGO } = await import('lib/pdfs/logo');

  return {
    margin: [0, -20, 0, 14],
    table: {
      widths: [140, '*', 130],
      body: [
        [
          {
            image: LOGO_CAJA,
            width: 130,
            alignment: 'center',
            margin: [0, 0, 0, 0],
            border: [false, false, false, false],
          },
          {
            stack: [
              {
                text: 'CAJA POPULAR 9 DE AGOSTO SALAMANCA, S.C. DE A.P. DE R.L. DE C.V.',
                bold: true,
                fontSize: 11,
                color: '#1a5fa8',
                alignment: 'center',
                margin: [0, 10, 0, 6],
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 10, y1: 0,
                    x2: 200, y2: 0,
                    lineWidth: 0.5,
                    lineColor: '#1a5fa8',
                  },
                ],
                margin: [0, 0, 0, 6],
              },
              {
                text: 'Juárez #408, Col. Centro, Salamanca, Gto., C.P. 36700',
                fontSize: 7.5,
                color: '#6c757d',
                alignment: 'center',
              },
              {
                text: '(464) 647 17 10',
                fontSize: 7.5,
                color: '#6c757d',
                alignment: 'center',
                margin: [0, 3, 0, 0],
              },
            ],
            border: [false, false, false, false],
          },
          {
            stack: [
              {
                text: 'Generado por',
                fontSize: 5,
                color: '#9aa5ad',
                alignment: 'right',
                margin: [0, 8, 0, 3],
              },
              {
                image: LOGO,
                width: 45,
                alignment: 'right',
                opacity: 0.55,
                margin: [0, 0, 0, 12],
              },
              titleConfig ? titleConfig : { text: '' },
            ],
            border: [false, false, false, false],
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
};


// WEBPACK FOOTER //
// src/lib/pdfs/Common.js